
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { store } from '@/store';
import dayjs from 'dayjs';

@Component
export default class DatePicker extends Vue {

    @Prop({default: new Date().toISOString().substr(0, 10)}) value!: string;
    @Prop({default: "Nuova data proposta"}) textBoxLabel!: string;
    @Prop({default: false}) "hide_details": boolean;
    @Prop({default: false}) "clearable": boolean;


    internalDate: string = '';
    dateFormatted: string = '';
    menu1 = false;

    @Watch('value', { immediate: true })
    onDatePropChange(): void {
        let internal = new Date().toISOString().substr(0, 10);
        if(this.value && this.value.length > 0) {
            internal = this.value;
        }
        else if(this.clearable)
        {
            internal = "";   
        }
        this.internalDate = internal;
    }

    @Watch('internalDate', { immediate: true })
    onDateChange(): void {
        this.dateFormatted = this.formatDate(this.internalDate);
        this.$emit('input', this.internalDate);
    }

    clear(){
        this.internalDate = "";
        this.$emit('input', this.internalDate);
    }
    formatDate (date: string): string {
        if (!date) return ''

        let [year, month, day] = date.split('-')
        if(day.includes('T')){
            day = day.split('T')[0];
        }
        return `${day}/${month}/${year}`
    }

    parseDate (date: string) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
}

